export default "__VITE_ASSET__BKf3NpJJ__"